import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as ChevronRightIcon } from '../../assets/images/svg/chevron-right.svg';
import themeColors from '../../assets/styles/themeColors';

const ChevronRightIconStyled = styled(ChevronRightIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const ChevronRight = (props) => <ChevronRightIconStyled {...props} />;

ChevronRight.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

ChevronRight.defaultProps = {
  w: '25px',
  h: '24px',
};

export default ChevronRight;
